import * as autocomplete from '@algolia/autocomplete-js';
import React, { createElement, Fragment, useEffect, useRef } from 'react';
import { createRoot, Root } from 'react-dom/client';
import { useNavigate } from "@remix-run/react";

// https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/basic-configuration-options/
// https://www.algolia.com/doc/ui-libraries/autocomplete/integrations/using-react/
// https://github.com/algolia/autocomplete/tree/next/examples/react-18
// https://codesandbox.io/p/sandbox/github/algolia/autocomplete/tree/next/examples/react-18
export function Autocomplete(props: any) {
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const panelRootRef = useRef<Root | null>(null);
  const rootRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) {
      return undefined;
    }

    const search = autocomplete.autocomplete({
      container: containerRef.current,
      // "detached mode" was caused scrolling issues on small screen sizes (mobile)
      // body.aa-Detached - was persisting even after selecting an item
      //   .aa-Detached {
      //     height: 100vh;
      //     overflow: hidden;
      // }
      // https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/detached-mode/
      detachedMediaQuery: 'none',
      renderer: { createElement, Fragment, render: () => {} },
      render({ children }, root) {
        if (!panelRootRef.current || rootRef.current !== root) {
          rootRef.current = root;

          panelRootRef.current?.unmount();
          panelRootRef.current = createRoot(root);
        }

        panelRootRef.current.render(children);
      },
      ...props,
    });

    return () => {
      search.destroy();
    };
  }, [props]);

  return <div ref={containerRef} className='w-full md:w-4/5 mx-auto mt-1' />;
}
